import { createContext } from "react";
export default createContext({
    account: {
        id: 0,
        name: "",
    },
    units: {
        admixRatioUnit: "",
        loadSizeUnit: "",
        slumpUnit: "",
        speedUnit: "",
        temperatureUnit: "",
        waterRatioUnit: "",
        waterVolumeUnit: "",
    },
    timeZone: "",
    defaultDate: new Date(),
});
//# sourceMappingURL=AccountContext.js.map